import { ChatMessengerState } from 'reducers/messenger/ChatMessengerState'

export const isTimestampIncorrect = (
  chatState: ChatMessengerState,
  timestamp: number
): boolean => {
  const incorrect =
    timestamp && chatState.chatData.lastMessageTimestamp! > timestamp

  if (incorrect) {
    console.warn(
      'Message: wrong timestamp diff',
      chatState.chatData.lastMessageTimestamp,
      timestamp
    )
  }

  return Boolean(incorrect)
}
